import React from 'react';
import { Plus, Globe, BookOpen } from 'lucide-react';

interface SidebarProps {
  mode: 'personal' | 'global';
  onModeChange: (mode: 'personal' | 'global') => void;
  onNewPrompt: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ mode, onModeChange, onNewPrompt }) => {
  return (
    <div className="fixed left-0 top-0 h-screen w-16 bg-dark-800 border-r border-dark-700 flex flex-col items-center gap-4 z-40 pt-36">
      {/* Biblioteca Pessoal */}
      <button
        onClick={() => onModeChange('personal')}
        className={`icon-btn ${mode === 'personal' ? 'active' : ''}`}
        data-label="BIBLIOTECA PESSOAL"
      >
        <BookOpen size={26} />
      </button>

      {/* Global */}
      <button
        onClick={() => onModeChange('global')}
        className={`icon-btn ${mode === 'global' ? 'active' : ''}`}
        data-label="GLOBAL PROMPT"
      >
        <Globe size={26} />
      </button>

      {/* Novo Prompt */}
      <button
        onClick={onNewPrompt}
        className="w-14 h-14 mt-auto mb-4 rounded-xl bg-purple-600 text-white hover:bg-purple-700 transition-all duration-200 flex items-center justify-center shadow-lg"
        data-label="NOVO PROMPT"
      >
        <Plus size={24} />
      </button>
    </div>
  );
};

export default Sidebar;